import { toast } from 'react-hot-toast';
import { api } from '../../services/authService';
import logger from '../../utils/logger';

// User Store - Kullanıcı bilgileri ve kimlik doğrulama için state yönetimi

// Auth durumu için başlangıç değerleri
const initialUserState = {
    user: null,
    token: null,
    isAuthenticated: false,
    isAdmin: false,
    isAgent: false,
    isSupervisor: false,
    loading: false,
    department: null
};

// Son token yenileme zamanı
let lastTokenRefresh = 0;
// Minimum token yenileme aralığı (5 saniye)
const MIN_REFRESH_INTERVAL = 5000;
// Maksimum yeniden deneme sayısı
const MAX_REFRESH_RETRIES = 3;

const createUserSlice = (set, get) => ({
    // State
    ...initialUserState,

    // Actions
    setUser: (user) => {
        if (!user) {
            set({
                user: null,
                isAuthenticated: false,
                isAdmin: false,
                isAgent: false,
                isSupervisor: false,
                department: null
            });
            return;
        }

        set({
            user,
            isAuthenticated: true,
            isAdmin: user?.role === 'admin',
            isAgent: user?.role === 'agent',
            isSupervisor: user?.role === 'supervisor',
            department: user?.department
        });
        // Kullanıcı bilgisi hiçbir storage'a yazılmaz — sadece memory (Zustand).
    },

    setToken: (token) => {
        // Access token yalnızca memory (Zustand store) içinde — localStorage/sessionStorage'a
        // hiç yazılmaz (XSS güvenliği). Refresh token zaten httpOnly cookie'de, JS'in eli değmez.
        set({ token });
    },

    logout: () => {
        set(initialUserState);
    },

    // Token yenileme — PLT-18 ile backend ucu silindi. Artık Keycloak updateToken akışına delege edilir.
    refreshToken: async (retryCount = 0) => {
        const now = Date.now();
        if (now - lastTokenRefresh < MIN_REFRESH_INTERVAL && retryCount === 0) {
            await new Promise(resolve => setTimeout(resolve, MIN_REFRESH_INTERVAL));
        }

        try {
            set({ loading: true });

            // Dinamik require BİLİNÇLİ: authService bu store'un getState()'ini
            // (setStoreGetter ile) tutuyor, üstteki statik import karşılıklı bağımlılık
            // yaratıp modül yükleme sırasına göre `undefined` verebiliyor. Çağrı anında
            // çözmek bu sırayı önemsiz kılıyor.
            const authService = require('../../services/authService').default;
            const result = await authService.refreshToken();

            if (result && result.token) {
                // authService.refreshToken token ve user'ı store'a kendisi yazıyor.
                set({ loading: false });
                lastTokenRefresh = Date.now();
                return true;
            }

            set({ loading: false });
            return false;
        } catch (err) {
            logger.error('Token yenileme (Keycloak) hatası:', err);
            set({ loading: false });
            return false;
        }
    },

    // Kullanıcı durumu
    userType: null, // 'customer' veya 'agent'
    userData: null,
    agents: [],
    waitingCustomers: [],
    waitingCount: 0,

    // ✅ Kimlik verilerini temizleme fonksiyonu
    clearIdentityData: () => {
        set({
            identityData: null,
            identityError: null,
            manualIdNumber: '',
            // Yüz görüntülerini de temizle
            faceImages: null,
            faceImagesError: null,
            isFaceImagesLoading: false,
            activeImageIndex: 0
        });
    },

    // Kullanıcı kaydı fonksiyonu (müşteri veya temsilci)
    registerUser: (type, data) => {
        const { socket } = get();

        if (!socket || !socket.connected) {
            return;
        }


        if (type === 'agent') {
            // Temsilci için email kontrolü - memory'deki (Zustand) oturum kullanıcısını al
            const userData = get().user;

            // Eğer login olmuş kullanıcı varsa, onun email bilgisini ekle
            if (userData && userData.email) {
                data.email = userData.email;
                data.username = userData.username || '';
            } else if (!data.email) {
                // Varsayılan bir email oluştur (Bu şekilde veritabanında kayıt oluşturulabilir)
                data.email = `${data.name.replace(/\s+/g, '.')}@videocall.example.com`.toLowerCase();
                data.username = data.name.replace(/\s+/g, '_').toLowerCase();
            }

            socket.emit('register-agent', data);
            set({ userType: 'agent', userData: data });
            // userType bilgisini de localStorage'a kaydet
            localStorage.setItem('userType', 'agent');
        } else if (type === 'customer') {
            socket.emit('register-customer', data);
            set({ userType: 'customer', userData: data });
            // userType bilgisini de localStorage'a kaydet
            localStorage.setItem('userType', 'customer');
        }
    }
});

export default createUserSlice; 
